import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "12",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1.045 11.2h11.91c.577 0 1.045-.456 1.045-1.018V1.018C14 .456 13.532 0 12.955 0H1.045C.468 0 0 .456 0 1.018v9.164c0 .562.468 1.018 1.045 1.018M.835 1.018c0-.112.095-.203.21-.203h11.91c.115 0 .21.091.21.203v7.309l-2.318-2.259a1.313 1.313 0 0 0-1.82 0l-.972.947-2.223-2.168a1.313 1.313 0 0 0-1.82 0L.836 7.944zm0 8.076 3.768-3.671a.46.46 0 0 1 .638 0l2.814 2.745 1.561-1.523a.46.46 0 0 1 .637 0l2.911 2.834v.703a.207.207 0 0 1-.209.204H1.045a.207.207 0 0 1-.21-.204z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.254 4.444c.691 0 1.253-.548 1.253-1.222S8.945 2 8.254 2C7.562 2 7 2.548 7 3.222s.562 1.222 1.254 1.222m0-1.63c.23 0 .418.184.418.408a.414.414 0 0 1-.418.407.414.414 0 0 1-.418-.407c0-.224.188-.407.418-.407"
    }, null, -1)
  ]))]))
}
export default { render: render }